export enum InspectionTypes {
  DAILY = 'DAILY',

  MAINTENANCE = 'MAINTENANCE',
}
